import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {store} from './reducer/store.js';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Provider store={store}><BrowserRouter><App /></BrowserRouter></Provider>);